module.exports = __webpack_public_path__ + "img/Eclipx_White_Transback.7b1acf2b.svg";